<template>
    <div class="signature-bg">
        <div class="w-full">
            <NuxtPage />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.signature-bg {
    background: url('/assets/images/soc/signature_bg.png');
    background-color: #18181B;
    height: 100vh;
    background-size: cover;
    background-attachment: fixed;
    overflow:auto;
    padding: 16px 8px;
}
</style>
